<script>
import baseList from "@/views/components/base/baseList.vue";
let customerId = window.localStorage.getItem("customerId");
export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: "callConfig",
        key: "id",
        url: {},
        output: false,
      },
      actions: [],
      menus: [],
      query: {},
      filters: [],
      tableCols: [
        {
          title: "坐席通道",
          key: "channelId",
          width: 120,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.channelId == 0
                ? "3"
                : row.channelId == 1
                ? "4"
                : row.channelId == 2
                ? "1"
                : row.channelId == 3
                ? "2"
                : "";
            return h(
              "div",
              {
                style: {
                  margin: "5px",
                  "font-size": "14px",
                  overflow: "hidden",
                  "text-overflow": "ellipsis",
                  "white-space": "nowrap",
                },
              },
              text
            );
          },
        },
        {
          title: "自定义名称",
          key: "channelName",
          minWidth: 160,
          align: "center",
        },
        {
          title: "修改时间",
          width: 150,
          align: "center",
          key: "updateTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.updateTime.slice(0, 16);
            return <span>{text}</span>;
          },
        },
        {
          title: "操作",
          align: "center",
          width: 160,
          key: "handle",
          handle: ["edit"],
        },
      ],
    };
  },
  created() {},
  methods: {
    handleEdit(currentRow) {
      let kv = currentRow.id;
      $utils.url.push({
        name: "callConfig_edit",
        query: { action: "edit", kv },
      });
    },
  },
};
</script>
